/*
 * View for the content page
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/contentsSplit/content/contentModification/template/contentModificationTemplate.html",
], function (Marionette, $, Messenger, ContentModificationTemplate) {
  var ContentModificationView = {};

  ContentModificationView.contentModificationView = Marionette.ItemView.extend({
    template: ContentModificationTemplate,
    onBeforeRender: function () {
      //set up the message for the bar and add it to the view model
      if (this.model) {
        var messageStr = "";
        if (this.model.get("isModified")) {
          var unixDate = this.model.get("modifiedDate");
          var localeDate = Messenger.reqres.request("get:formatted:date", unixDate);
          messageStr = $.t("contents.headers.modifiedOn", { date: localeDate });
        } else if (this.model.get("isIgnored")) {
          messageStr = $.t("contents.headers.ignored");
        } else if (this.model.get("isMissing")) {
          var localeDate = Messenger.reqres.request(
            "get:formatted:date",
            this.model.get("modifiedDate"),
          );
          messageStr = $.t("contents.headers.missing", { date: localeDate });
        } else {
          //everything is ok message
          messageStr = $.t("contents.headers.approved");
        }
        this.model.messageString = messageStr;
      }
    },
    onBeforeClose: function () {
      //stop listening for clicks
      $("html").off("click.ak.content-mod");
    },
    triggers: {
      "click #approveModifications": "approve:modifications",
      "click #ignoreModifications": "ignore:modifications",
      "click #stopIgnoringModifications": "stop:ignoring:modifications",
    },
  });

  return ContentModificationView;
});
